/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
    if ((typeof attribute) !== 'string') {
        attribute += '';
        if (attribute === 'undefined') {
            attribute = '';
        }
    }
    return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
    // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
    var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/update.js',
            data: 'note=' + attributeToString(note),
            dataType: 'json',
            beforeSend: function() {
                $body.trigger('beforeUpdateCartNote.ajaxCart', note);
            },
            success: function(cart) {
                if ((typeof callback) === 'function') {
                    callback(cart);
                }
                else {
                    ShopifyAPI.onCartUpdate(cart);
                }
                $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
            },
            error: function(XMLHttpRequest, textStatus) {
                $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
                ShopifyAPI.onError(XMLHttpRequest, textStatus);
            },
            complete: function(jqxhr, text) {
                $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
            }
        };
    jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    if (!!data.message) {
        alert(data.message + '(' + data.status  + '): ' + data.description);
    }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
    var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/add.js',
            data: jQuery(form).serialize(),
            dataType: 'json',
            beforeSend: function(jqxhr, settings) {
                $body.trigger('beforeAddItem.ajaxCart', form);
            },
            success: function(line_item) {
                if ((typeof callback) === 'function') {
                    callback(line_item, form);
                }
                else {
                    ShopifyAPI.onItemAdded(line_item, form);
                }
                $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
            },
            error: function(XMLHttpRequest, textStatus) {
                if ((typeof errorCallback) === 'function') {
                    errorCallback(XMLHttpRequest, textStatus);
                }
                else {
                    ShopifyAPI.onError(XMLHttpRequest, textStatus);
                }
                $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
            },
            complete: function(jqxhr, text) {

                $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
            }
        };
    jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
    $(document.body).trigger('beforeGetCart.ajaxCart');
    jQuery.getJSON('/cart.js', function (cart, textStatus) {
        if ((typeof callback) === 'function') {
            callback(cart);
        }
        else {
            ShopifyAPI.onCartUpdate(cart);
        }
        $(document.body).trigger('afterGetCart.ajaxCart', cart);
    });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
    var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/change.js',
            data: 'quantity=' + quantity + '&line=' + line,
            dataType: 'json',
            beforeSend: function() {
                $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
            },
            success: function(cart) {
                if ((typeof callback) === 'function') {
                    callback(cart);
                }
                else {
                    ShopifyAPI.onCartUpdate(cart);
                }
                $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
                ShopifyAPI.updateFreeProduct(quantity);
            },
            error: function(XMLHttpRequest, textStatus) {
                $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
                ShopifyAPI.onError(XMLHttpRequest, textStatus);
            },
            complete: function(jqxhr, text) {
                $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
            }
        };
    jQuery.ajax(params);
};

// We add the bonus product to the cart
// product id = 3770122666018;
// variant id = 28894971887650

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.updateFreeProduct = function(quantity, callback) {
    //

    var data = { updates: {} };

    var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/update.js',
            data: data,
            dataType: 'json',
            beforeSend: function() {
                $body.trigger('beforeChangeItem.ajaxCart', [quantity]);
            },
            success: function(cart) {
                if ((typeof callback) === 'function') {
                    callback(cart);
                }
                else {
                    ShopifyAPI.onCartUpdate(cart);
                }
                $body.trigger('afterChangeItem.ajaxCart', [quantity, cart]);
            },
        };
    jQuery.ajax(params);
};


/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

    'use strict';

    // Public functions
    var init, loadCart;

    // Private general variables
    var settings, isUpdating, $body;

    // Private plugin variables
    var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

    // Private functions
    var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, isProductPage, adjustCartCallback, createQtySelectors, qtySelectors, validateQty, mastheadShipping;

    /*============================================================================
      Initialise the plugin and define global options
    ==============================================================================*/
    init = function (options) {

        // Default settings
        settings = {
            formSelector       : 'form[action^="/cart/add"]',
            cartContainer      : '#CartContainer',
            addToCartSelector  : 'input[type="submit"]',
            cartCountSelector  : null,
            cartCostSelector   : null,
            moneyFormat        : '$',
            disableAjaxCart    : false,
            enableQtySelectors : true
        };

        // Override defaults with arguments
        $.extend(settings, options);

        // Select DOM elements
        $formContainer     = $(settings.formSelector);
        $cartContainer     = $(settings.cartContainer);
        $addToCart         = $formContainer.find(settings.addToCartSelector);
        $cartCountSelector = $(settings.cartCountSelector);
        $cartCostSelector  = $(settings.cartCostSelector);

        // General Selectors
        $body = $(document.body);

        // Track cart activity status
        isUpdating = false;

        // Setup ajax quantity selectors on the any template if enableQtySelectors is true
        if (settings.enableQtySelectors) {
            qtySelectors();
        }

        // Take over the add to cart form submit action if ajax enabled
        if (!settings.disableAjaxCart && $addToCart.length) {
            formOverride();
        }

        // Run this function in case we're using the quantity selector outside of the cart
        adjustCart();
    };

    loadCart = function () {
        $body.addClass('drawer--is-loading');

        jQuery.getJSON('/cart.js', function (cart) {

            // get cart item count, load the free product script and then load the cart up as before in callback.
            ShopifyAPI.updateFreeProduct( cart.item_count, cartUpdateCallback);
        });

    };

    updateCountPrice = function (cart) {
        if ($cartCountSelector) {
            $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

            if (cart.item_count === 0) {
                $cartCountSelector.addClass('hidden-count');
            }
        }
        if ($cartCostSelector) {
            $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
        }
    };

    formOverride = function () {
        $formContainer.on('submit', function(evt) {
            evt.preventDefault();

            // Add class to be styled if desired
            $addToCart.removeClass('is-added').addClass('is-adding');

            // Remove any previous quantity errors
            $('.qty-error').remove();

            ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
        });
    };

    itemAddedCallback = function (product) {
        $addToCart.removeClass('is-adding').addClass('is-added');
        ShopifyAPI.getCart(cartUpdateCallback);
    };

    itemErrorCallback = function (XMLHttpRequest, textStatus) {
        var data = eval('(' + XMLHttpRequest.responseText + ')');
        $addToCart.removeClass('is-adding is-added');

        if (!!data.message) {
            if (data.status == 422) {
                $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
            }
        }
    };

    cartUpdateCallback = function (cart) {

        // Update quantity and price
        updateCountPrice(cart);
        buildCart(cart);

    };

    mastheadShipping = function (cart) {
        // We need to update our shipping message to reflect the amount they have to spend to get free shipping
        // countryCode is a global variable set in the main.js file.

        var geoCountryCode = countryCode;

        var mastheadCurrency = $('.dynamic-shipping-message').data("currency");
        if (geoCountryCode == 'GB' || geoCountryCode == 'US') {
            var freeShippingValue = $('.dynamic-shipping-message').data("usukfree");
        } else {
            var freeShippingValue = $('.dynamic-shipping-message').data("shipping");
        }

        /* Free shipping message temporarily disabled
        if (cart.item_count > 0) {

            var priceToGo = Number(freeShippingValue - cart.total_price / 100).toFixed(2);

            if (priceToGo > 0) {
                $('.dynamic-shipping-message').html('Spend another <span class="fs-16 text-color-yellow bold">' + mastheadCurrency + priceToGo + '</span> to qualify for <span class="fs-16 text-color-yellow bold">FREE</span> shipping!');
            } else {
                $('.dynamic-shipping-message').html('Your cart qualifies for <span class="fs-16 text-color-yellow bold">FREE</span> Shipping!');
            }

        } else {

            $('.dynamic-shipping-message').html('Free Worldwide Shipping on Orders over ' + mastheadCurrency + freeShippingValue);

        }
        */

    }

    buildCart = function (cart) {

        // Start with a fresh cart div
        $cartContainer.empty();

        // Show empty cart
        if (cart.item_count === 0) {
            $cartContainer
                .append('<p>' + "Your cart is currently empty." + '</p>');
            cartCallback(cart);
            return;
        }

        // Handlebars.js cart layout
        var items = [],
            item = {},
            data = {},
            source = $("#CartTemplate").html(),
            template = Handlebars.compile(source);

        // Add each item to our handlebars.js data
        $.each(cart.items, function(index, cartItem) {

            /* Hack to get product image thumbnail
             *   - If image is not null
             *     - Remove file extension, add _small, and re-add extension
             *     - Create server relative link
             *   - A hard-coded url of no-image
            */

            if (cartItem.image != null){
                var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_large$1").replace('http:', '');
            } else {
                var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
            }

            prodImg = "https://cdn.shopify.com/s/files/1/0606/0159/8205/files/1-box-200px-wide.png?v=1658331780";
            

            // Setting variables for Quantity 1 and 2 variables, we use them to pass to handlebars in ajax-cart-template.liquid
            // And add an upsell message to the cart drawer if the user has one or two of a product in the cart
            var qty1 = false;
            var qty2 = false;
            var over2 = false;
            var freeItem = true;

            if (cartItem.quantity%3 == 1) {
                qty1 = true;
            } else if (cartItem.quantity%3 == 2) {
                qty2 = true;
            }

            if (cartItem.quantity > 2) {
                over2 = true;
            }

            if (cartItem.price == 0) {
                freeItem = false;
            }


            // Remove the querystring and find the product handle
            var urlNoQuery = cartItem.url.split("?")[0];
            var productHandle = '';
            var productHandle = urlNoQuery.split('/').slice(-1)[0];


            // We need to check if the cart item is a subscription product
            // If so we assign the qty1 and qty2 values as false to prevent the display of the cart message
            //
            var intervalType = '';
            var intervalValue = '';
            var subscription = false;

            var onetime = true;

            $.each(cartItem.properties, function(index, property) {
                if( index.includes('shipping_interval_unit_type')) {
                    // We set the qty1 and qty2 values to false when its a subscription product so no discount message
                    // is shown
                    qty1 = false;
                    qty2 = false;
                    onetime = false;
                    intervalType = property;
                    subscription = true;
                } else if (index.includes('shipping_interval_frequency')) {
                    intervalValue = property;
                }

            });

            if (subscription) {
                // Reset the property
                cartItem.properties = {};
                cartItem.properties['Billing & Delivery Interval'] = intervalValue +' '+ intervalType;
            }

            // Create item's data object and add to 'items' array
            item = {
                key: cartItem.key,
                line: index + 1, // Shopify uses a 1+ index in the API
                url: cartItem.url,
                img: prodImg,
                name: cartItem.product_title,
                variation: cartItem.variant_title,
                properties: cartItem.properties,
                itemAdd: cartItem.quantity + 1,
                itemMinus: cartItem.quantity - 1,
                itemQty: cartItem.quantity,
                qtyOne: qty1,
                qtyTwo: qty2,
                overTwo: over2,
                notFree: freeItem,
                onetimePurchase: onetime,
                productHandle: productHandle,
                price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
                vendor: cartItem.vendor,
                linePrice: Shopify.formatMoney(cartItem.line_price, settings.moneyFormat),
                originalLinePrice: Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat),
                discounts: cartItem.discounts,
                discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true
            };

            items.push(item);

            // We remove the subscription feedback box
            $('.frequency-selection-text').html();
            $('.frequency-selection').hide();


        });

        // Gather all cart data and add to DOM
        data = {
            items: items,
            note: cart.note,
            totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
            totalCartDiscount: cart.total_discount === 0 ? 0 : "You're saving [savings]".replace('[savings]', Shopify.formatMoney(cart.total_discount, settings.moneyFormat)),
            totalCartDiscountApplied: cart.total_discount === 0 ? false : true
        }

        $cartContainer.append(template(data));

        cartCallback(cart);
    };

    cartCallback = function(cart) {
        $body.removeClass('drawer--is-loading');
        $body.trigger('afterCartLoad.ajaxCart', cart);

        if (window.Shopify && Shopify.StorefrontExpressButtons) {
            Shopify.StorefrontExpressButtons.initialize();
        }

        // We need to change the moving menu if the cart contains a product
        if (cart.item_count > 0) {

            $("#masthead-nav").addClass("cartloaded");

        } else {

            $("#masthead-nav").removeClass("cartloaded");

        }

        // Update the cart counter
        $('.cart-counter').html(cart.item_count);
        // We need to update our shipping message to reflect the amount they have to spend to get free shipping
        mastheadShipping(cart);

    };

    adjustCart = function () {
        // Delegate all events because elements reload with the cart

        // This is for the cart drawer removal button
        $body.on('click', '.trash-icon', function() {
            if (isUpdating) {
                return;
            }

            var $el = $(this),
                line = $el.data('line');

            var qty = 0;
            // If it has a data-line, update the cart.
            // Otherwise, just update the input's number
            if (line) {
                updateQuantity(line, qty);
            }

        });


        // Apply this only to the Qty updater in the subscription block
        // Note it's initially hidden so we bind to body
        $body.on('click','#rc_autodeliver_options .js-qty__adjust, #rc_autodeliver_options .ajaxcart__qty-adjust', function(){
            if (isUpdating) {
                return;
            }

            var $el = $(this),
                $qtySelector = $el.siblings('.js-qty__num'),
                qty = parseInt($qtySelector.val().replace(/\D/g, ''));

            checkPageTriggerUpdate(qty);

            // We need to update the delivery message if it's shown, but only if a frequency is selected
            if ($("#set_first_option").hasClass("selected")) {
                frequencyText(4, qty);
            } else if ($("#set_second_option").hasClass("selected")) {
                frequencyText(5, qty);
            } else if ($("#set_third_option").hasClass("selected")) {
                frequencyText(8, qty);
            } else if ($("#set_fourth_option").hasClass("selected")) {
                frequencyText(12, qty);
            }
        });


        // Add or remove from the quantity
        $body.on('click', '.ajaxcart__qty-adjust', function() {
            if (isUpdating) {
                return;
            }

            var $el = $(this),
                line = $el.data('line'),
                $qtySelector = $el.siblings('.ajaxcart__qty-num'),
                qty = parseInt($qtySelector.val().replace(/\D/g, ''));

            var qty = validateQty(qty);

            // Add or subtract from the current quantity
            if ($el.hasClass('ajaxcart__qty--plus')) {
                qty += 1;
            } else {
                qty -= 1;
                if (qty <= 0) qty = 0;
            }

            // If it has a data-line, update the cart.
            // Otherwise, just update the input's number
            if (line) {
                updateQuantity(line, qty);
            } else {
                $qtySelector.val(qty);
            }
        });

        // Update quantity based on input on change
        $body.on('change', '.ajaxcart__qty-num', function() {
            if (isUpdating) {
                return;
            }

            var $el = $(this),
                line = $el.data('line'),
                qty = parseInt($el.val().replace(/\D/g, ''));

            var qty = validateQty(qty);

            // If it has a data-line, update the cart
            if (line) {
                updateQuantity(line, qty);
            }
        });

        // Prevent cart from being submitted while quantities are changing
        $body.on('submit', 'form.ajaxcart', function(evt) {
            if (isUpdating) {
                evt.preventDefault();
            }
        });

        // Highlight the text when focused
        $body.on('focus', '.ajaxcart__qty-adjust', function() {
            var $el = $(this);
            setTimeout(function() {
                $el.select();
            }, 50);
        });

        function updateQuantity(line, qty) {
            isUpdating = true;

            // Add activity classes when changing cart quantities
            var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

            if (qty === 0) {
                $row.parent().addClass('is-removed');
            }

            // Slight delay to make sure removed animation is done

            setTimeout(function() {
                ShopifyAPI.changeItem(line, qty, adjustCartCallback);
            }, 250);

        }

        // Save note anytime it's changed
        $body.on('change', 'textarea[name="note"]', function() {
            var newNote = $(this).val();

            // Update the cart note in case they don't click update/checkout
            ShopifyAPI.updateCartNote(newNote, function(cart) {});
        });

        // McNab - we close the drawer when 'Continue Shopping is clicked
        // If we are on a product page and there is a stacks section we scroll to the stacks.

        $body.on('click', '#continue-shopping-button', function() {
            if ($('body').hasClass("js-drawer-open")) {
                $(".js-drawer-close").trigger("click");

                var onProductPage = document.getElementById("productstacks");
                if (onProductPage) {
                    // Desired offset, in pixels
                    var offset = 200;
                    // Desired time to scroll, in milliseconds
                    var scrollTime = 500;

                    $("html, body").animate({
                        scrollTop: $(onProductPage).offset().top - offset
                    }, scrollTime);
                }
            }
        });

    };

    isProductPage = function() {

        // If we are on a product page we need to reload the prices in the Top 3 section to reflect the volume discount
        var urlfragment = location.pathname.split('/').slice(-2, -1)[0];

        if (urlfragment == 'products') {
            return true;
        }

        return false;

    }

    adjustCartCallback = function (cart) {
        // Update quantity and price
        updateCountPrice(cart);

        // Update the cart counter
        $('.cart-counter').html(cart.item_count);

        mastheadShipping(cart);

        // Reprint cart on short timeout so you don't see the content being removed
        setTimeout(function() {
            isUpdating = false;
            ShopifyAPI.getCart(buildCart);
        }, 250)
    };


    createQtySelectors = function() {
        // If there is a normal quantity number field in the ajax cart, replace it with our version
        if ($('input[type="number"]', $cartContainer).length) {
            $('input[type="number"]', $cartContainer).each(function() {
                var $el = $(this),
                    currentQty = $el.val();

                var itemAdd = currentQty + 1,
                    itemMinus = currentQty - 1,
                    itemQty = currentQty;

                var source   = $("#AjaxQty").html(),
                    template = Handlebars.compile(source),
                    data = {
                        key: $el.data('id'),
                        itemQty: itemQty,
                        itemAdd: itemAdd,
                        itemMinus: itemMinus
                    };

                // Append new quantity selector then remove original
                $el.after(template(data)).remove();
            });
        }
    };

    qtySelectors = function() {
        // Change number inputs to JS ones, similar to ajax cart but without API integration.
        // Make sure to add the existing name and id to the new input element
        var numInputs = $('input[type="number"]');

        if (numInputs.length) {
            numInputs.each(function() {
                var $el = $(this),
                    currentQty = $el.val(),
                    inputName = $el.attr('name'),
                    inputId = $el.attr('id');

                var itemAdd = currentQty + 1,
                    itemMinus = currentQty - 1,
                    itemQty = currentQty;

                var source   = $("#JsQty").html(),
                    template = Handlebars.compile(source),
                    data = {
                        key: $el.data('id'),
                        itemQty: itemQty,
                        itemAdd: itemAdd,
                        itemMinus: itemMinus,
                        inputName: inputName,
                        inputId: inputId
                    };

                // Append new quantity selector then remove original
                $el.after(template(data)).remove();
            });

            // Setup listeners to add/subtract from the input
            $('.js-qty__adjust').on('click', function() {
                var $el = $(this),
                    id = $el.data('id'),
                    $qtySelector = $el.siblings('.js-qty__num'),
                    qty = parseInt($qtySelector.val().replace(/\D/g, ''));

                var qty = validateQty(qty);

                // Add or subtract from the current quantity
                if ($el.hasClass('js-qty__adjust--plus')) {
                    qty += 1;

                    // MLP Check - Need to ad extra box
                } else {
                    qty -= 1;
                    if (qty <= 1) qty = 1;
                }

                // Update the input's number
                $qtySelector.val(qty);

                // If on the cart page we need to fake the update button form submit on qty change
                var finalPathPart = location.pathname.split('/').slice(-1)[0];
                if (finalPathPart == 'cart') {
                    $(this).closest('form').submit();
                }

                // We need to update the subscription text if on a product page with a subscription chosen
                var dynamicRechargeQty = document.getElementById("recharge-frequency-qty");
                if (dynamicRechargeQty) {
                    $('#recharge-frequency-qty').html(qty);
                }

            });
        }
    };

    validateQty = function (qty) {
        if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
            // We have a valid number!
        } else {
            // Not a number. Default to 1.
            qty = 1;
        }
        return qty;
    };

    module = {
        init: init,
        load: loadCart
    };

    return module;

}(ajaxCart || {}, jQuery));
